import request from "../../utils/request";
import commonFun from "@/utils/commonFun";

export const fileService = {
    sqmsFileUpload: (data, factorType, ttQspiFacilityFactorScoreId) => {
        return request({
            url: `file/${factorType}/${ttQspiFacilityFactorScoreId}`,
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data; charset=UTF-8",
            },
            data: data,
        });
    },
    //文件上传
    fileUpload: (data) => {
        return request({
            url: "/file",
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data; charset=UTF-8",
            },
            data: data,
        });
    },
    rmcFileUpload: (recType, seq, bizId, attachmentName) => {
        return request({
            url: `/file/${recType}/${seq}/${bizId}/${attachmentName}`,
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data; charset=UTF-8",
            },
            data: {},
        });
    },
    //文件上传
    fileUploadLms: (data) => {
        return request({
            url: "/file/lms",
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data; charset=UTF-8",
            },
            data: data,
        });
    },
    //BC pdf上传
    BCfileUploadPDF: (data) => {
        return request({
            url: "/file/uploadPdfAndAddMark",
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data; charset=UTF-8",
            },
            data: data,
        });
    },
    fileUploadRmcProt(recType, seq, bizId, files) {
        return request({
            url: `/file/${recType}/${seq}/${bizId}`,
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data; charset=UTF-8",
            },
            data: files,
        });
    },
    fileUploadWithReplationShip(recType, seq, recId, files) {
        return request({
            url: `/file/${recType}/${seq}/${recId}`,
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data; charset=UTF-8",
            },
            data: files,
        });
    },
    //文件下载
    downloadFile: (row) => {
        request({
            url: "/file/download",
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            responseType: "blob",
            data: row.tmDocumentId,
        }).then((res) => {
            if (window.navigator.msSaveBlob) {
                try {
                    let data = new Blob([res]);
                    window.navigator.msSaveBlob(data, row.documentName);
                } catch (e) {
                    this.$message({ type: "error", message: "文件下载失败" });
                }
            } else {
                try {
                    const link = document.createElement("a");
                    let blob = new Blob([res], { type: row.downloadType });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob); //创建下载的链接
                    link.setAttribute("download", row.documentName); //下载后文件名
                    document.body.appendChild(link);
                    link.click(); //模拟在按钮上的一次鼠标单击
                    document.body.removeChild(link); //释放URL 对象
                } catch (e) {
                    this.$message({ type: "error", message: "文件下载失败" });
                }
            }
        });
    },
    //文件下载法务用印文件
    downloadFileLms: (row) => {
        request({
            url: "/file/download/lms",
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            responseType: "blob",
            data: row.tmDocumentId,
        }).then((res) => {
            console.log(res);
            if (window.navigator.msSaveBlob) {
                try {
                    let data = new Blob([res]);
                    window.navigator.msSaveBlob(data, row.documentName);
                } catch (e) {
                    this.$message({ type: "error", message: "文件下载失败" });
                }
            } else {
                try {
                    const link = document.createElement("a");
                    console.log(row);
                    let blob = new Blob([res], { type: row.downloadType });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob); //创建下载的链接
                    link.setAttribute("download", row.documentName); //下载后文件名
                    document.body.appendChild(link);
                    link.click(); //模拟在按钮上的一次鼠标单击
                    document.body.removeChild(link); //释放URL 对象
                } catch (e) {
                    this.$message({ type: "error", message: "文件下载失败" });
                }
            }
        });
    },
    //拜访计划PDF下载
    downloadFileFDP: (row, tmDocumentId, ttMsvReportId) => {
        request({
            url: "msv-report/downloadMsvReportPdf/" + tmDocumentId + "/" + ttMsvReportId,
            method: "get",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            responseType: "blob",
        }).then((res) => {
            if (window.navigator.msSaveBlob) {
                try {
                    let data = new Blob([res]);
                    window.navigator.msSaveBlob(data, row.documentName);
                } catch (e) {
                    this.$message({ type: "error", message: "文件下载失败" });
                }
            } else {
                try {
                    const link = document.createElement("a");
                    let blob = new Blob([res], { type: row.downloadType });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob); //创建下载的链接
                    link.setAttribute("download", row.documentName); //下载后文件名
                    document.body.appendChild(link);
                    link.click(); //模拟在按钮上的一次鼠标单击
                    document.body.removeChild(link); //释放URL 对象
                } catch (e) {
                    this.$message({ type: "error", message: "文件下载失败" });
                }
            }
        });
    },
    //文件关系保存
    saveFile: (data) => {
        return request({
            url: "/file/saveFile",
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //文件关系删除
    deleteFile: (data) => {
        return request({
            url: "/file/deleteFile",
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //文件列表获取
    getFileList: (data) => {
        return request({
            url: "/file/fileList",
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    countFile: (data) => {
        return request({
            url: "/file/countFile",
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    /**
     * @param resp
     * @param newFileName  文件名称，有值使用指定的值名称文件（xxx.xxx）
     */
    respToFile: (resp, newFileName) => {
        console.log("resp", resp);
        let fileBolb = resp.data;
        console.log("fileBolb", fileBolb);
        let headers = resp.headers;
        console.log("headers", headers);
        let fileName = newFileName;
        console.log("fileName", fileName);
        if (commonFun.isEmpty(fileName)) {
            fileName = commonFun.trim(
                decodeURIComponent(
                    escape(headers["content-disposition"].split("=")[1])
                ).trim('"'),
                '"'
            );
        }
        if (window.navigator.msSaveBlob) {
            try {
                window.navigator.msSaveBlob(fileBolb, fileName);
            } catch (e) {
                console.error(e);
                this.$message({ type: "error", message: "文件下载失败" });
            }
        } else {
            try {
                const link = document.createElement("a");
                let blob = new Blob([fileBolb], { type: fileBolb.type });
                link.style.display = "none";
                link.href = URL.createObjectURL(blob); //创建下载的链接
                link.setAttribute("download", fileName); //下载后文件名
                document.body.appendChild(link);
                link.click(); //模拟在按钮上的一次鼠标单击
                document.body.removeChild(link); //释放URL 对象
            } catch (e) {
                console.error(e);
                this.$message({ type: "error", message: "文件下载失败" });
            }
        }
    },
    // 从头部获取文件名并且转码
    resNameToFile: (resp) => {
        console.log("resp", resp);
        let fileBolb = resp.data;
        console.log("fileBolb", fileBolb);
        let headers = resp.headers;
        console.log("headers", headers);
        let fileName = ''
        if (headers["content-disposition"]) {
            fileName = headers["content-disposition"].split(';')[1].split("filename=")[1];
            fileName = decodeURI(fileName)
            console.log("fileName", fileName);
        }
        if (commonFun.isEmpty(fileName)) {
            console.log("走下判断")
            fileName = commonFun.trim(
                decodeURIComponent(
                    escape(headers["content-disposition"].split("=")[1])
                ).trim('"'),
                '"'
            );
        }
        if (window.navigator.msSaveBlob) {
            try {
                window.navigator.msSaveBlob(fileBolb, fileName);
            } catch (e) {
                console.error(e);
                this.$message({ type: "error", message: "文件下载失败" });
            }
        } else {
            try {
                const link = document.createElement("a");
                let blob = new Blob([fileBolb], { type: fileBolb.type });
                link.style.display = "none";
                link.href = URL.createObjectURL(blob); //创建下载的链接
                link.setAttribute("download", fileName); //下载后文件名
                document.body.appendChild(link);
                link.click(); //模拟在按钮上的一次鼠标单击
                document.body.removeChild(link); //释放URL 对象
            } catch (e) {
                console.error(e);
                this.$message({ type: "error", message: "文件下载失败" });
            }
        }
    },
    //模版下载
    downloadTemplate: (path, name) => {
        request({
            url: "file/downloadTemplate",
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            responseType: "blob",
            data: path,
        }).then((res) => {
            if (window.navigator.msSaveBlob) {
                try {
                    let data = new Blob([res]);
                    window.navigator.msSaveBlob(data, name);
                } catch (e) {
                    this.$message({ type: "error", message: "文件下载失败" });
                }
            } else {
                try {
                    const link = document.createElement("a");
                    let blob = new Blob([res], { type: res.type });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob); //创建下载的链接
                    link.setAttribute("download", name); //下载后文件名
                    document.body.appendChild(link);
                    link.click(); //模拟在按钮上的一次鼠标单击
                    document.body.removeChild(link); //释放URL 对象
                } catch (e) {
                    console.log("文件下载失败");
                }
            }
        });
    },
    changeFileName: (fileName, id) => {
        return request({
            url: "file/changeFileName/" + id,
            method: "post",
            data: fileName,
        });
    },
    downLoadZip: (data) => {
        return request({
            url: "/file/downloadZip",
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            responseType: "blob",
            fullResponse: true,
            data: data,
        });
    },
};